import api from './api';

export const reviewService = {
  // Create a new review
  async createReview(reviewData) {
    try {
      const response = await api.post('/reviews', reviewData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get reviews for a specific service
  async getServiceReviews(serviceType, serviceId, options = {}) {
    try {
      const params = new URLSearchParams();
      
      if (options.page) params.append('page', options.page);
      if (options.limit) params.append('limit', options.limit);
      if (options.statut) params.append('statut', options.statut);
      if (options.sortBy) params.append('sortBy', options.sortBy);
      if (options.rating) params.append('rating', options.rating);
      
      const response = await api.get(
        `/reviews/service/${serviceType}/${serviceId}?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get user's own reviews
  async getUserReviews(options = {}) {
    try {
      const params = new URLSearchParams();
      
      if (options.page) params.append('page', options.page);
      if (options.limit) params.append('limit', options.limit);
      
      const response = await api.get(`/reviews/my-reviews?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Vote for helpful review
  async voteHelpful(reviewId) {
    try {
      const response = await api.post(`/reviews/${reviewId}/vote`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin functions
  admin: {
    // Get all reviews (admin)
    async getAllReviews(options = {}) {
      try {
        const params = new URLSearchParams();
        
        if (options.page) params.append('page', options.page);
        if (options.limit) params.append('limit', options.limit);
        if (options.statut) params.append('statut', options.statut);
        if (options.serviceType) params.append('serviceType', options.serviceType);
        
        const response = await api.get(`/reviews/admin/all?${params.toString()}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // Get review statistics
    async getReviewStats() {
      try {
        const response = await api.get('/reviews/admin/stats');
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // Get single review by ID
    async getReviewById(reviewId) {
      try {
        const response = await api.get(`/reviews/admin/${reviewId}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // Update review status
    async updateReviewStatus(reviewId, statut, reponse_admin = null) {
      try {
        const response = await api.put(`/reviews/admin/${reviewId}/status`, {
          statut,
          reponse_admin
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // Delete review
    async deleteReview(reviewId) {
      try {
        const response = await api.delete(`/reviews/admin/${reviewId}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};

export default reviewService;